module.exports = __webpack_public_path__ + "static/item-section-1-a37e8f165f531482499cc58ed9e8a609.png";